import { CustomMedicalType, medicalTypes as defaultMedicalTypes } from "@teamprevent/common/healthSurveillance/models";

export const getMedicalTypeName = (customMedicalTypes: CustomMedicalType[] | undefined, medicalTypeid: string) =>
    [...defaultMedicalTypes, ...customMedicalTypes ?? []].find(m => m.id === medicalTypeid)?.name ?? medicalTypeid;
